// npm
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

// css
import '../../scss/pages/page-recruit.scss';

// libs

// utils
import Ease from '../_utils/Ease';
import RecruitFoundation from '../_utils/RecruitFoundation';
import { getCssVar } from '../_utils/Utils';
import RecruitMouseStalker from '../_libs/RecruitMouseStalker';
RecruitFoundation();

document.addEventListener('DOMContentLoaded', () => {
	// op
	const $mv = document.querySelector('.js-mv');
	if ($mv) {
		const $mvSlider = $mv.querySelector('.js-mv-slider');
		const $$mvSliderItem = $mvSlider.querySelectorAll('.js-mv-slider-item');

		const totalCount = $$mvSliderItem.length;

		// スライダーの初期値
		let index = 0;
		let indexPrev = totalCount - 1;
		let indexNext = 1;

		function nextSlide(indexCuurent) {
			index = indexCuurent;
			indexPrev = index - 1 < 0 ? totalCount - 1 : index - 1;
			indexNext = index + 1 > totalCount - 1 ? 0 : index + 1;

			$$mvSliderItem.forEach(($item, i) => {
				$item.classList.remove('is-active', 'is-prev', 'is-next');

				if (i === index) {
					$item.classList.add('is-active');
				} else if (i === indexPrev) {
					$item.classList.add('is-prev');
				} else if (i === indexNext) {
					$item.classList.add('is-next');
				}
			});
		}
		nextSlide(index);

		const $imageBackgroundTop = $mv.querySelector(
			'.js-mv-image-background-top'
		);
		const $imageBackgroundBottom = $mv.querySelector(
			'.js-mv-image-background-bottom'
		);
		const $headline = $mv.querySelector('.js-mv-headline');

		gsap.set($imageBackgroundTop, {
			xPercent: -101,
		});

		gsap.set($imageBackgroundBottom, {
			xPercent: 101,
		});

		gsap.set($mvSlider, {
			scale: 1.05,
			opacity: 0,
		});

		gsap.set($headline, {
			opacity: 0,
		});

		gsap.set($mv, {
			opacity: 1,
		});

		const op = gsap.timeline({
			delay: 0.4,
			onComplete: () => {
				setInterval(() => {
					nextSlide(index + 1 > totalCount - 1 ? 0 : index + 1);
				}, 4000);
			},
		});

		op.to($imageBackgroundTop, {
			duration: 0.8,
			xPercent: 0,
			ease: Ease.SineInExpoOut,
		});

		op.to(
			$imageBackgroundBottom,
			{
				duration: 0.8,
				xPercent: 0,
				ease: Ease.SineInExpoOut,
			},
			'<'
		);

		op.to(
			$imageBackgroundTop,
			{
				duration: 0.4,
				xPercent: 101,
				ease: Ease.DoubleSineOut,
			},
			'+=0.2'
		);

		op.to(
			$imageBackgroundBottom,
			{
				duration: 0.4,
				xPercent: -101,
				ease: Ease.DoubleSineOut,
			},
			'<'
		);

		op.to(
			$mvSlider,
			{
				duration: 0.8,
				scale: 1,
				opacity: 1,
				ease: Ease.DoubleSineOut,
			},
			'<'
		);

		op.to(
			$headline,
			{
				duration: 0.4,
				opacity: 1,
				ease: Ease.DoubleSineOut,
			},
			'<'
		);

		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						document.documentElement.classList.remove('is-mv');
					} else {
						document.documentElement.classList.add('is-mv');
					}
				});
			},
			{
				rootMargin: '0px',
			}
		);

		observer.observe($mv);
	}

	const $copy = document.querySelector('.js-copy');
	if ($copy) {
		const $house = $copy.querySelector('.js-copy-house');

		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						entry.target.classList.add('is-active');

						observer.disconnect();
					}
				});
			},
			{
				rootMargin: '0px 0px -35% 0px',
			}
		);
		observer.observe($house);

		const $paragraph = $copy.querySelector('.js-copy-paragraph');
		const $$paragraphChar = $paragraph.querySelectorAll('.char');

		if ($$paragraphChar.length > 0) {
			gsap.fromTo(
				$$paragraphChar,
				{
					opacity: 0.2,
					display: 'inline-block',
				},
				{
					opacity: 1,
					stagger: 0.01,
					ease: Ease.DoubleSineOut,
					duration: 1,
					scrollTrigger: {
						trigger: $paragraph,
						start: 'top 80%',
						end: 'bottom 80%',
						once: true,
					},
				}
			);
		}
	}

	const $number = document.querySelector('.js-number');
	if ($number) {
		const $$item = $number.querySelectorAll('.js-number-item');
		const $headline = $number.querySelector('.js-number-headline');
		const $icon = $number.querySelector('.js-number-icon');

		const getRandom = (min, max) => {
			const result = gsap.utils.random(min, max, 0.01);
			return result;
		};

		gsap.set([$headline, $icon], {
			opacity: 0,
		});

		$$item.forEach(($item) => {
			const x = getCssVar($item, '--_x');
			const y = getCssVar($item, '--_y');

			if ($item === $$item[$$item.length - 1]) {
				gsap.fromTo(
					$item,
					{
						opacity: 0,
						xPercent: x,
						yPercent: y,
					},
					{
						opacity: 1,
						xPercent: 0,
						yPercent: 0,
						duration: 1,
						delay: getRandom(0, 0.12),
						ease: Ease.DoubleSineOut,
						scrollTrigger: {
							trigger: $number,
							start: 'top 80%',
							end: 'bottom 80%',
							once: true,
						},
						onComplete: () => {
							$item.classList.add('is-hover');

							// インラインプロパティをリセット
							gsap.set($item, {
								clearProps: 'all',
							});

							gsap.fromTo(
								$headline,
								{
									opacity: 0,
								},
								{
									opacity: 1,
									duration: 0.4,
									ease: Ease.DoubleSineOut,
								}
							);

							gsap.fromTo(
								$icon,
								{
									opacity: 0,
								},
								{
									opacity: 1,
									duration: 0.4,
									ease: Ease.DoubleSineOut,
								}
							);
						},
					}
				);
			} else {
				gsap.fromTo(
					$item,
					{
						opacity: 0,
						xPercent: x,
						yPercent: y,
					},
					{
						opacity: 1,
						xPercent: 0,
						yPercent: 0,
						duration: 1,
						delay: getRandom(0, 0.5),
						ease: Ease.DoubleSineOut,
						scrollTrigger: {
							trigger: $number,
							start: 'top 80%',
							end: 'bottom 80%',
							once: true,
						},
						onComplete: () => {
							$item.classList.add('is-hover');

							// インラインプロパティをリセット
							gsap.set($item, {
								clearProps: 'all',
							});
						},
					}
				);
			}
		});
	}
});

window.addEventListener('load', () => {
	RecruitMouseStalker();
});
